import { useCallback, useEffect, useState } from "react";
import { v4 as uuid } from "uuid";
import useForgeRock from "../../../hooks/useForgeRock";
import { termsOfUseItem, termsOfUseResponse } from "../../../types/TermsOfUse";
import { baseUrl } from "services/apis";

export const getTnCs = ()=>( {
  headers: {
    TransactionId: uuid(),
    ApplicationId: process.env.REACT_APP_EmployerTnC_AppID ?? "",
  },
  url: `${baseUrl}/TnC/v1`,
  method: "GET",
});


export const getLatestTnc = (termsOfuseList: termsOfUseItem[]) => {
  if (!termsOfuseList || termsOfuseList.length < 1) {
    return undefined;
  }
  termsOfuseList.sort(
    (a, b) =>
      new Date(b.creationDate).getTime() - new Date(a.creationDate).getTime(),
  );
  return termsOfuseList[0];
};

const useTermsandCondtions = () => {
  const { APICall } = useForgeRock();

  const [tncDocument, setTNCDocument] = useState("");
  const [loadingTnc, setLoadingTnc] = useState(true);
  const [errorLoadingTnc, setErrorLoadingTnc] = useState<undefined | string>(
    undefined,
  );

  const getTNCs = useCallback(async () => {
    try {
      setLoadingTnc(true);
      const TnCResponse: termsOfUseResponse = await APICall(getTnCs());
      if (TnCResponse.resultCode === -1) {
        setErrorLoadingTnc("Terms and condtions failed to load");
        return;
      }
      if (!TnCResponse.response || TnCResponse.response.length < 1) {
        setErrorLoadingTnc("Terms and condtions do not exist");
        return;
      }
      const latest = getLatestTnc(TnCResponse.response);
      if (!latest) {
        setErrorLoadingTnc("Cant find the latest terms and condtions");
        return;
      }
      setTNCDocument(latest.document);
    } catch {
      setErrorLoadingTnc(
        "Terms and condtions failed to load due to an exception",
      );
      return;
    } finally {
      setLoadingTnc(false);
    }
  }, []);

  useEffect(() => {
    getTNCs();
  }, [getTNCs]);

  return { tncDocument, loadingTnc, errorLoadingTnc, setErrorLoadingTnc };
};

export default useTermsandCondtions;
